// Owner 2026-10-09: a validation error (HTTP 422 from the server) names the
// FIELD and its ROW in Indonesian, e.g. "Nama & nomor baris 3 — Ukuran: wajib
// diisi" instead of "String should have at least 1 character". No imports, so
// Jest can test it.

const DAFTAR = {
  variasi: "Barang jersey (Bagian 2)", tambahan: "Barang tambahan", pemain: "Nama & nomor",
  items: "Barang", alokasi: "Pembagian penjahit", butir: "Checklist", komponen: "Komponen",
};
const KOLOM = {
  customer_id: "Customer", designer_id: "Desainer", barang_id: "Barang", bahan_id: "Bahan", supplier_id: "Supplier",
  qty: "Qty", quantity: "Qty", diskon: "Diskon", catatan: "Catatan", nama: "Nama", nomor: "Nomor punggung",
  ukuran: "Ukuran", lengan: "Lengan", variasi_no: "No. variasi", jenis_jersey: "Jenis jersey", model: "Model",
  kerah: "Kerah", bahan: "Bahan", warna: "Warna", motif: "Motif", cutting: "Cutting", ukuran_ringkas: "Ukuran (ringkas)",
  tim_komunitas: "Tim / komunitas", pic_nama: "Nama PIC", pic_whatsapp: "WhatsApp PIC",
  tanggal_ambil_kirim: "Tanggal ambil/kirim", cara_serah: "Cara serah", layanan: "Layanan",
  ukuran_custom_catatan: "Catatan ukuran custom", tanpa_ppn_alasan: "Alasan tanpa PPN", alasan: "Alasan",
  nomor_telepon: "Nomor telepon", username: "Username", password: "Password", nominal: "Nominal", jumlah: "Jumlah",
  keterangan: "Keterangan", reject_reason: "Alasan reject", qty_reject: "Qty reject", pcs_bermasalah: "Pcs/pemain bermasalah",
  operator_id: "Penjahit", pcs: "Pcs", p_cm: "Panjang (cm)", l_cm: "Lebar (cm)", tanggal: "Tanggal",
};

const tanpaPrefix = (m) => String(m || "").replace(/^Value error, /, "");

function pesan(e) {
  const c = e.ctx || {};
  switch (e.type) {
    case "missing": return "wajib diisi";
    case "string_too_short": return c.min_length === 1 ? "wajib diisi" : `minimal ${c.min_length} karakter`;
    case "string_too_long": return `maksimal ${c.max_length} karakter`;
    case "too_short": return c.min_length === 1 ? "minimal 1 baris" : `minimal ${c.min_length} baris`;
    case "too_long": return `maksimal ${c.max_length} baris`;
    case "int_parsing": case "int_type": case "int_from_float": return "harus angka bulat";
    case "float_parsing": case "decimal_parsing": return "harus angka";
    case "greater_than_equal": return `minimal ${c.ge}`;
    case "greater_than": return `harus lebih dari ${c.gt}`;
    case "less_than_equal": return `maksimal ${c.le}`;
    case "literal_error": case "enum": return "pilihan tidak valid";
    case "date_parsing": case "date_from_datetime_parsing": return "tanggal tidak valid";
    case "string_pattern_mismatch": return "format tidak valid";
    case "bool_parsing": return "harus ya/tidak";
    default: return tanpaPrefix(e.msg);
  }
}

// ["body", "pemain", 2, "ukuran"] → "Nama & nomor baris 3 — Ukuran"
export function lokasi(loc) {
  const p = (loc || []).filter((x) => x !== "body" && x !== "query" && x !== "path");
  const out = [];
  for (let i = 0; i < p.length; i += 1) {
    const k = p[i];
    if (typeof k === "number") continue;
    const baris = typeof p[i + 1] === "number" ? p[i + 1] + 1 : null;
    const label = DAFTAR[k] || KOLOM[k] || String(k).replace(/_/g, " ");
    out.push(baris ? `${label} baris ${baris}` : label);
  }
  return out.join(" — ");
}

export function pesanValidasi(detail) {
  if (!Array.isArray(detail)) return null;
  return detail.map((e) => {
    if (!e || typeof e !== "object") return String(e);
    const l = lokasi(e.loc);
    return l ? `${l}: ${pesan(e)}` : pesan(e);
  }).join(" · ");
}
